var SENTRY_RELEASE;SENTRY_RELEASE={name: "Abo Omar Dashboard", version: "0.7.26"};